import { useBindAccount } from '@flowus/login/hook/use-bind-account';
import { CaptchaComp } from '@flowus/login/uikit/web/captcha';
import { CaptchaSendType } from '@next-space/fe-api-idl';
import type { FC } from 'react';
import { useState } from 'react';
import { useAppTranslation } from '@flowus/common/i18n';
import { Button } from 'src/common/components/button';
import { Input } from 'src/common/components/input';
import { request } from 'src/common/request';
import { $currentUserCache } from 'src/services/user/current-user';
import { Regex } from 'src/utils';
import { initLogin } from 'src/utils/init-login';

interface Props {
  onSuccess: () => void;
}

export const BindEmail: FC<Props> = (props) => {
  const { t } = useAppTranslation();
  const {
    email,
    setEmail,
    emailError,
    verifyCode,
    setVerifyCode,
    verifyCodeError,
    bind,
    sendVerifyCode,
  } = useBindEmail();
  return (
    <div className="p-7 w-[400px]">
      <div className="text-t1-medium ">{t('common.bind_email')}</div>
      <Input
        autoFocus
        warning={emailError}
        className="w-full h-9 mt-5"
        inputClassName="opacity-50"
        value={email}
        placeholder={t('components.login_uikit.enter_email')}
        onChange={setEmail}
      />
      <Input
        type="number"
        value={verifyCode}
        maxLength={6}
        warning={verifyCodeError}
        className="w-full h-9 mt-5 px-3"
        inputClassName="opacity-50 px-0"
        placeholder={t('common.enter_verification_code')}
        onChange={(v) => setVerifyCode(v.toString())}
        addonAfter={
          <CaptchaComp
            onSendVerifyCode={() => {
              return sendVerifyCode();
            }}
          />
        }
      />
      <Button
        onClick={async () => {
          const success = await bind();
          if (success) props.onSuccess();
        }}
        colorType="active"
        className="mt-6"
      >
        {t('components.login_uikit.complete_binding')}
      </Button>
    </div>
  );
};
// 需要初始化一些数据
initLogin();
const useBindEmail = () => {
  const { t } = useAppTranslation();
  const [email, setEmail] = useState<string>('');
  const [emailError, setEmailError] = useState<string>();
  const [verifyCode, setVerifyCode] = useState('');
  const [verifyCodeError, setVerifyCodeError] = useState('');
  const { bindEmail } = useBindAccount();

  const checkEmail = () => {
    if (!Regex.Email.test(email)) {
      setEmailError(t('components.login_uikit.invalid_email_format'));
      return false;
    }
    return true;
  };
  const checkVerifyCode = () => {
    if (!Regex.VerifyCode.test(verifyCode)) {
      setVerifyCodeError(t('common.verification_code_error'));
      return false;
    }
    return true;
  };
  const sendVerifyCode = async () => {
    if (!checkEmail()) return;
    return request.infra.emailCaptcha({
      email,
      type: CaptchaSendType.BIND_NEW,
    });
  };
  /** 设置邮箱 */
  const bind = async () => {
    if (!checkEmail()) return;
    if (!checkVerifyCode()) return;
    return bindEmail($currentUserCache.uuid, email, verifyCode);
  };
  return {
    email,
    emailError,
    verifyCode,
    verifyCodeError,
    setEmail,
    setVerifyCode,
    sendVerifyCode,
    bind,
  };
};
